import { render } from "./UniversalIconWithHint.vue?vue&type=template&id=c5fb4d30&scoped=true&ts=true"
import script from "./UniversalIconWithHint.vue?vue&type=script&lang=ts"
export * from "./UniversalIconWithHint.vue?vue&type=script&lang=ts"

import "./UniversalIconWithHint.vue?vue&type=style&index=0&id=c5fb4d30&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5fb4d30"]])

export default __exports__